import { render, staticRenderFns } from "./PassengersData.vue?vue&type=template&id=761d1b55&scoped=true&"
import script from "./PassengersData.vue?vue&type=script&lang=js&"
export * from "./PassengersData.vue?vue&type=script&lang=js&"
import style0 from "./PassengersData.vue?vue&type=style&index=0&id=761d1b55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761d1b55",
  null
  
)

export default component.exports